// src/utils/searchUtilsForAccounts.js

/**
 * Lowercases and strips diacritics (é -> e, ô -> o, etc.) so search is
 * accent-insensitive. Must match exactly what the SQL backfill below does
 * (lower(unaccent(...))), or the ilike comparison won't line up.
 */
export const normalizeSearchText = (str) => {
    return (str || '')
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();
};
